// extracted by mini-css-extract-plugin
module.exports = {"TabelHolder":"SupportListTabel_TabelHolder__3Tlaq"};